export default __webpack_public_path__ + "static/media/logo-locked.5ac762f6.svg";